import $ from 'jquery';
import React from 'react';

import {BULK_ASSEMBLY_SCREEN} from 'bulk-workflows/assembly/BulkAssemblyConstants';
import BulkAssemblyEditor from 'bulk-workflows/assembly/BulkAssemblyEditor';
import {BulkWorkflowScreen} from 'bulk-workflows/BulkWorkflowComponents';
import {BULK_TRANSLATION_SCREEN} from 'bulk-workflows/translation/BulkTranslationConstants';
import BulkTranslationPage from 'bulk-workflows/translation/BulkTranslationPage';
import DataConnector from 'connect/DataConnector';
import {MODEL_HUB_SCREEN} from 'model-hub/ModelHubConstants';
import ModelHubScreen from 'model-hub/ModelHubScreen';
import * as NewUserFlowConstants from 'onboarding/new-user-flow/NewUserFlowConstants';
import NewUserFlowView from 'onboarding/new-user-flow/NewUserFlowView';
import * as RegistryActivationFlowConstants from 'onboarding/registry-activation-flow/RegistryActivationFlowConstants';
import RegistryActivationFlowView from 'onboarding/registry-activation-flow/RegistryActivationFlowView';
import * as OrganizationConstants from 'orgs/OrganizationConstants';
import PartyFullScreenView from 'orgs/PartyFullScreenView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as TenantAdminConstants from 'tenants/admin/TenantAdminConstants';
import TenantFullScreenView from 'tenants/admin/TenantFullScreenView';

import {isInScreenSubset, LOADING_SCREEN, Screen} from './FullScreenConstants';
import FullScreenStore from './FullScreenStore';
import LoadingFullScreen from './LoadingFullScreen';

export function initFullScreen(): void {
  const $fullScreenNode = $('.full-screen-mount');
  renderToDOM(<ConnectedFullScreen />, $fullScreenNode[0]);
}

interface FullScreenEnhancedProps {
  currentScreen: Screen | null;
}

class FullScreenConnector extends DataConnector<{}, FullScreenEnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [FullScreenStore];

  enhanceProps(): FullScreenEnhancedProps {
    return {currentScreen: this.fullScreenStore().getCurrentScreen()};
  }
}

class FullScreen extends React.Component<FullScreenEnhancedProps> {
  override componentDidMount(): void {
    this.setBodyClass();
  }

  override componentDidUpdate(): void {
    this.setBodyClass();
  }

  /**
   * If there is a full screen to render hide .subworkspace (buffers, toolbar, statusbar).
   */
  setBodyClass(): void {
    $(document.body).toggleClass('has-shown-full-screen', this.props.currentScreen != null);
    $('#wrapper').toggleClass(
      'signup-flow-v2',
      this.props.currentScreen != null &&
        NewUserFlowConstants.ALL_SCREENS.includes(
          this.props.currentScreen as NewUserFlowConstants.NewUserFlowScreen
        )
    );
  }

  override render(): JSX.Element | null {
    if (this.props.currentScreen == null) {
      return <div />;
    }
    if (isInScreenSubset(this.props.currentScreen, NewUserFlowConstants.ALL_SCREENS)) {
      return <NewUserFlowView currentScreen={this.props.currentScreen} />;
    }
    if (isInScreenSubset(this.props.currentScreen, RegistryActivationFlowConstants.ALL_SCREENS)) {
      return <RegistryActivationFlowView currentScreen={this.props.currentScreen} />;
    }
    if (isInScreenSubset(this.props.currentScreen, OrganizationConstants.ALL_SCREENS)) {
      return <PartyFullScreenView currentScreen={this.props.currentScreen} />;
    }
    if (isInScreenSubset(this.props.currentScreen, TenantAdminConstants.ALL_SCREENS)) {
      return <TenantFullScreenView currentScreen={this.props.currentScreen} />;
    }
    if (this.props.currentScreen === MODEL_HUB_SCREEN) {
      return <ModelHubScreen />;
    }
    if (this.props.currentScreen === LOADING_SCREEN) {
      return <LoadingFullScreen />;
    }
    if (this.props.currentScreen === BULK_ASSEMBLY_SCREEN) {
      return (
        <BulkWorkflowScreen>
          <BulkAssemblyEditor />
        </BulkWorkflowScreen>
      );
    }
    if (this.props.currentScreen === BULK_TRANSLATION_SCREEN) {
      return (
        <BulkWorkflowScreen>
          <BulkTranslationPage />
        </BulkWorkflowScreen>
      );
    }
    return null;
  }
}

const ConnectedFullScreen = FullScreenConnector.connect(FullScreen);

export default ConnectedFullScreen;
